import { Outlet } from "react-router-dom";

const CouponsPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default CouponsPageLayout;